import { DataTable } from "lib/@components/data-table/data-table"
import { Bound } from "lib/@components/binding/Bound"
import { useSearchParam } from "lib/@hooks/use-search-param"
import { RegimeTableRow } from "./regime-table-row"
import { cleanRegimeName } from "./clean-regime-name"
import { RegimeStateFilter } from "./regime-state-filter"
import { getRegimeStates } from "./regime-states"
import { RegimeTableColumns } from "./regime-management-event-definitions.mjs"

export function RegimeTableView({ items = [] }) {
    const [search] = useSearchParam("search", "")
    const [stateSearch, setStateSearch] = useSearchParam("regimeState", "")
    const selectedStates = stateSearch ? stateSearch.split(",") : []
    const extraColumns = RegimeTableColumns.call({ columns: [] }).columns
    const columns = buildColumns()
    const filtered = selectedStates.length ? items.filter(matchesStateFilter) : items
    const rows = filtered.map(toRow)

    return (
        <Bound regimeTableColumns={extraColumns}>
            <DataTable
                columns={columns}
                RowComponent={<RegimeTableRow />}
                items={rows}
                isFiltered={selectedStates.length > 0 || !!search}
                refreshKey={`${search}|${stateSearch}`}
                sortKey="regime-list-sort"
                pageSizeKey="regime-page-size"
                defaultSort={{ field: "name", descending: false }}
            />
        </Bound>
    )

    function buildColumns() {
        return [
            { field: "name", label: "Name", sortable: true },
            {
                field: "state",
                label: "State",
                width: 150,
                filter: <RegimeStateFilter selectedStates={selectedStates} onChange={setSelectedStates} />,
            },
            ...extraColumns,
            { field: "access", label: "Access", width: 160 },
            { field: "modified", label: "Modified", sortable: true, width: 150 },
            { field: "actions", label: "", width: 56, align: "right" },
        ]
    }

    function matchesStateFilter(item) {
        return getRegimeStates(item).some((state) => selectedStates.includes(state))
    }

    function setSelectedStates(next) {
        setStateSearch(next.join(","))
    }

    function toRow(item) {
        const row = { ...item, name: cleanRegimeName(item.label), modified: item.$?.modified }
        // A plugin column can give a value per regime so the table can sort by it.
        for (const column of extraColumns) {
            if (column.value) row[column.field] = column.value(item)
        }
        return row
    }
}
